import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/relationship-scores/profile/loading';

export const Route = createFileRoute('/_private/settings/relationship-scores/$id')({
  pendingComponent: Loading,
});
